import React, { useMemo } from 'react';
import styled from 'styled-components';

import ButtonBase from '@mui/material/ButtonBase';
import Menu from '@mui/material/Menu';

import MenuListItem from 'ff/debrief/components/menu/MenuListItem';
import { useChrono, useAnalytics } from 'ff/debrief/hooks';

interface Props {
    currentSpeed: number;
    onSpeedChange: (speed: number) => void;
}

const SpeedSelectDropdown: React.FC<Props> = props => {
    const anchorElRef = React.useRef(null);
    const [isOpen, setIsOpen] = React.useState(false);

    const { isTicking } = useChrono();
    const { logTimelineSpeedChanged } = useAnalytics();

    const formattedSpeed = useMemo(() => {
        return speedOptions.find(o => o.value === props.currentSpeed).label;
    }, [props.currentSpeed]);

    const handleButtonClick = () => {
        setIsOpen(!isOpen);
    };

    const handleClose = () => {
        setIsOpen(false);
    };

    const handleMenuItemClick = (value: number) => {
        logTimelineSpeedChanged({
            speed: value,
            whilePlaying: isTicking,
        });
        props.onSpeedChange(value);
        handleClose();
    };

    return (
        <>
            <SpeedButton ref={anchorElRef} onClick={handleButtonClick}>
                {formattedSpeed}
            </SpeedButton>
            <Menu
                open={isOpen}
                anchorEl={anchorElRef.current}
                onClose={handleClose}
            >
                {speedOptions.map(option => (
                    <MenuListItem
                        key={option.value}
                        value={option.value}
                        onClick={handleMenuItemClick}
                    >
                        {option.label}
                    </MenuListItem>
                ))}
            </Menu>
        </>
    );
};

const speedOptions = [
    { value: 1, label: 'Speed 1x' },
    { value: 5, label: 'Speed 5x' },
    { value: 10, label: 'Speed 10x' },
    { value: 20, label: 'Speed 20x' },
];

const SpeedButton = styled(ButtonBase)`
    border-radius: 3px;
    border: 1px solid #becad4;
    white-space: nowrap;
    padding: 4px;
`;

export default SpeedSelectDropdown;
